//import {Link} from 'react-router-dom';
import React/*, {useState}*/ from 'react';

import {useracc, postApi, deleteApi} from '../../utils/functions';
import {UserContext} from '../../utils/usercontext';
import EventEmitter from '../../utils/emmiter';

import AudioPlayer from '../components/audio/audio';
import DJAreaSideMenu from './sidemenu';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

export default class AdminPublish extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
			publish: {},
			published: {},
			deleted: {},
		};
		this.loadPublishings = this.loadPublishings.bind(this);
		this.deleteListing = this.deleteListing.bind(this);
  };

  //loading:any = React.createRef();
  
  async componentDidMount() {
		document.title = "Admin Publish - Mix365 Radio";
		const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );
		EventEmitter.emit('/client', {data: 'no value'});

		await this.loadPublishings();
	}

	componentWillUnmount() {
	}

	async loadPublishings() {
		var params = new URLSearchParams();
		const x = await postApi('/api/v2/admin/publish', params);
		this.setState({publish: x.data.publish, published: x.data.published});
	}

	async publishListing(id) {
	}

	async deleteListing(id) {
		if( window.confirm("Are you sure you wish to delete this publishing?")) {
			var params = new URLSearchParams();
			params.append('id', id)
			await deleteApi('/api/v2/admin/publish/delete', params);
			await this.loadPublishings();
		}
	}

	

	render() {
		const publish = 
      Object.keys(this.state.publish).map((e,i) => {
        return (
					<div className="row px-4 py-3 p-schedule-event">
						<div className="col-12">
							<AudioPlayer audio={this.state.publish[e]} />
						</div>
						
					</div>
				)
      })
		const published = 
      Object.keys(this.state.published).map((e,i) => {
        return (
					<div className="row px-4 py-3 p-schedule-event">
						<div className="col-12">
							<AudioPlayer audio={this.state.published[e]} />
						</div>
					</div>
				)
      })
		return (
			<Row className="dj-area pt-4 pb-5 px-4">
				<Col xs={12} md={2} className="djarea-sidemenu">
					<DJAreaSideMenu />
				</Col>
				<Col>
					<Row>

						<div className="col-12 col-sm-9 col-lg-10">


							<div className="row text-white admin-panel">
								<div className="col-12 admin-panel-header">
									Unpublished Shows
								</div>
								<div className="col-12 admin-panel-body">
									{publish}

								</div>
							</div>


							<div className="row mt-5 text-white admin-panel">
								<div className="col-12 admin-panel-header">
									Published Shows
								</div>
								<div className="col-12 admin-panel-body">
									{published}
								</div>
							</div>

						</div>
					</Row>
				</Col>
			</Row>
		);
	}
}
